// extracted by mini-css-extract-plugin
export default {"ColumnLayout":"ColumnLayout_ColumnLayout__KbTNF","Column":"ColumnLayout_Column__VJo4L"};